export enum LLMModelType {
    Reasoning = 'Reasoning',
    NonReasoning = 'NonReasoning',
}